// REACT & REDUX
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// STYLE, PROPS & TRANSLATIONS
import { translate } from 'react-i18next';

// COMMON

// COMPONENTS
import  Upload  from './Upload.component';
import { CERTIFICATE_SUBMIT_FORM } from '../../actions/actionTypes';
import { uploadCertificate } from '../../actions/certificate.actions';
import { submit } from 'redux-form';

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************
function mapStateToProps(state) {
    return {
        files: state.files,
        clientSecrets: state.clientSecrets,
        disableUploadButton:state.uploadFiles.disableUploadButton

    };
}

const mapDispatchToProps = dispatch => {
    return {
        submitForm: () => { dispatch(submit(CERTIFICATE_SUBMIT_FORM)) },
        upload: (a, b) => { dispatch(uploadCertificate(a, b)); }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Upload);